"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Contact = _interopRequireDefault(require("../../Organisms/Contact"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _PageHeaderText = _interopRequireDefault(require("../../TextElements/BasicTextElements/PageHeaderText"));

var _ParagraphText = _interopRequireDefault(require("../../TextElements/BasicTextElements/ParagraphText"));

var _NotFound = require("./NotFound.styles");

var _strings = require("../../../constants/strings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ## external ##
// ## ours ##
// ## resources ##

/** Pre-baked NotFound page content.
 *  Will use standard notFound page strings for header, sub-header and body by default.
 *  MUST be placed within our standard LayoutOneColumn's body section for proper display.
 */
var NotFound = function NotFound(_ref) {
  var header = _ref.header,
      subHeader = _ref.subHeader,
      body = _ref.body,
      phoneNo = _ref.phoneNo,
      businessHours = _ref.businessHours,
      email = _ref.email;
  return /*#__PURE__*/_react.default.createElement(_NotFound.StyledNotFound, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    dataTestId: "not-found-alert-icon",
    className: "c-not-found-alert-icon",
    iconName: "exclamation-triangle",
    colorTheme: "cta"
  })), /*#__PURE__*/_react.default.createElement(_PageHeaderText.default, {
    dataTestId: "not-found-header"
  }, header || _strings.notFound.header), /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
    dataTestId: "not-found-sub-header"
  }, /*#__PURE__*/_react.default.createElement("strong", null, subHeader || _strings.notFound.subHeader)), /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
    dataTestId: "not-found-body"
  }, body || _strings.notFound.body), /*#__PURE__*/_react.default.createElement(_Contact.default, {
    className: "c-not-found-contact-text",
    dataTestId: "not-found-contact",
    phoneNo: phoneNo,
    businessHours: businessHours,
    email: email
  }));
};

NotFound.propTypes = {
  /** body text */
  body: _propTypes.default.string,
  // dataTestId is intentionally omitted from this class as it is just a wrapper

  /** Primary header text */
  header: _propTypes.default.string,

  /** Sub-header text */
  subHeader: _propTypes.default.string,

  /** Contact phone number */
  phoneNo: _propTypes.default.string,

  /** Contact Business Hours */
  businessHours: _propTypes.default.string,

  /** Contact Email */
  email: _propTypes.default.string
};
NotFound.defaultProps = {
  header: '',
  subHeader: '',
  body: '',
  phoneNo: '(833) 230-2253',
  businessHours: 'Cake\'s hours are Monday-Friday, 8am-5pm MT',
  email: 'support@cakeinsure.com'
};
var _default = NotFound;
exports.default = _default;